// Extraído mecanicamente do artefato original recuperado.
export const TERM_WORDS = [
  "TERMO",
  "FESTA",
  "JOGAR",
  "LIVRO",
  "CARRO",
  "TEMPO",
  "PORTA",
  "MUNDO",
  "NOITE",
  "CHUVA",
  "FOGOS",
  "TERRA",
  "VENTO",
  "SORTE",
  "AMIGO",
  "FELIZ",
  "JUSTO",
  "LUGAR",
  "VALOR",
  "PODER",
  "REGRA",
  "PAPEL",
  "CASAS",
  "FOLHA",
  "PRAIA",
  "CAMPO",
  "FONTE",
  "PEDRA",
  "FRUTA",
  "ROUPA",
  "SONHO",
  "FLORA",
  "RISCO",
  "MAGIA",
  "CORPO",
  "MENTE",
  "MORRO",
  "PONTE",
  "NUVEM",
  "AREIA",
  "TRIGO",
  "MILHO",
  "VELHO",
  "JOVEM",
  "CLARO",
  "BRAVO",
  "MANSO",
  "LIMPO",
  "SUAVE",
  "FORTE",
  "FRACO",
  "RAPAZ",
  "MOCAS",
  "HOMEM",
  "BEBER",
  "COMER",
  "ANDAR",
  "NADAR",
  "OUVIR",
  "FALAR",
  "OLHAR",
  "TARDE",
  "ONTEM",
  "ANTES",
  "SALTO",
  "DANCA",
  "MUSGO",
  "CESTA",
  "PRATO",
  "COPOS",
  "GARFO",
  "TINTA",
  "LINHA",
  "TECER",
  "CANTO",
  "RISOS",
  "PLANO",
  "METAL",
  "IDEIA",
  "CURSO",
  "AULAS",
  "PROVA",
  "NOTAS",
  "GRUPO",
  "LIDER",
  "HONRA",
  "REINO",
  "NAVIO",
  "ILHAS",
  "VAZIO",
  "CHEIO",
  "DOCES",
  "MELAO",
  "SAGAZ",
  "NEGRO",
  "EXITO",
  "MEXER",
  "NOBRE",
  "SENSO",
  "AFETO",
  "PLENA",
  "FAZER",
  "ASSIM",
  "MUDAR",
  "VIGOR",
  "FUGIR",
  "VILAO",
  "SANTO",
  "CRIAR",
  "IDEAL",
  "VISAO",
  "CULTA",
  "LOUCO",
  "FICAR",
  "SABIA",
  "AMPLA",
  "SABER",
  "VIVER",
  "POBRE",
  "CALMA",
  "MORTE",
  "VETOR",
  "FALSO",
  "FOCAR",
  "PONTO",
  "BLOCO",
  "LETRA",
  "MESMO",
  "COISA",
  "DONOS",
  "DEUSA",
  "FRUTO",
  "LEGAL",
  "MURAL",
  "CLIMA",
  "VERDE",
  "PRETO",
  "CINZA",
  "PRATA",
  "TURMA",
  "SINAL",
  "POUCO",
  "MUITO",
  "LENTO",
  "TENSO",
  "DENSO",
  "POETA",
  "BANCO",
  "TIGRE",
  "LEOES",
  "ZEBRA",
  "COBRA",
  "CALOR",
  "FUSCA",
  "BICHO",
  "CAIXA",
  "BOLSA",
  "CHAVE",
  "DOIDO",
  "LOUCA",
  "GATOS",
  "PEIXE",
  "BARCO",
  "SABIO",
  "VOGAL",
  "FINAL",
  "RESTO",
  "PIADA",
  "SAIDA",
  "CUSTO",
  "CARTA",
  "CENAS",
  "VAMOS",
  "CALCA",
  "BLUSA",
  "TEXTO",
  "FUNDO",
  "BAIXO",
  "SITIO",
  "FAROL",
  "LEITE",
  "CARNE",
  "TORTA",
  "ZEBUS",
  "PANDA",
  "FOCAS",
  "LEBRE",
  "GRILO",
  "SAPOS",
  "ARARA",
  "LINCE",
  "MORSA",
  "MOSCA",
  "PULGA",
  "LARVA",
  "TRACA",
  "LIMAO",
  "MAMAO",
  "PERAS",
  "COCOS",
  "FIGOS",
  "ARROZ",
  "AVEIA",
  "ATRIZ",
  "CHEFE",
  "MONGE",
  "PADRE",
  "SAIAS",
  "MEIAS",
  "LUVAS",
  "BOTAS",
  "TENIS",
  "CINTO",
  "GORRO",
  "BONES",
  "VASOS",
  "LILAS",
  "BEGES",
  "MAGOA",
  "ICONE",
  "ORGAO",
  "PULAR",
  "MORAR",
  "LUTAR",
  "ABRIR",
  "SUBIR",
  "GRITO",
  "CHUTE",
  "GOLPE",
  "TOQUE",
  "BEIJO",
  "SORRI",
  "TOURO",
  "PORCO",
  "RATOS",
  "AGUIA",
  "PONEI",
  "URSOS",
  "LOBOS",
  "GALOS",
  "PATOS",
  "PATAS",
  "VACAS",
  "UMIDO",
  "MACIO",
  "ATIVO",
  "LIVRE",
  "LARGO",
  "CURTO",
  "SUJOS",
  "AGUDO",
  "DENTE",
  "OSSOS",
  "PELOS",
  "UNHAS",
  "BOCAS",
  "NARIZ",
  "BRACO",
  "CINCO",
  "LULAS",
  "CAMAS",
  "VARAS",
  "CONES",
  "SINOS",
  "CANAS",
  "MOLAS",
  "TROPA",
  "GIGAS",
  "FREVO",
  "TREVO",
  "MEDOS",
  "DEDOS",
  "TENTO",
  "ERROS",
  "JATOS",
  "NORTE",
  "CORTE",
  "GUELA",
  "MURRO",
  "BURRO",
  "TAPAS",
  "MALAS",
  "FALAS",
  "ACIDO",
  "AGORA",
  "AJUDA",
  "AMIGA",
  "ANJOS",
  "ANUAL",
  "APOIO",
  "AREAS",
  "ARTES",
  "ASTRO",
  "ATUAL",
  "AUTOR",
  "BALAO",
  "BANDA",
  "BANHO",
  "BARBA",
  "BARRO",
  "BAZAR",
  "BEMOL",
  "BOMBA",
  "BORDA",
  "CABOS",
  "CACTO",
  "CALVO",
  "CANAL",
  "CANOS",
  "CAPAS",
  "CARAS",
  "CASAL",
  "CETRO",
  "CHATO",
  "CHORO",
  "CICLO",
  "CIPOS",
  "CIVIL",
  "CLARA",
  "CLERO",
  "CLONE",
  "CLUBE",
  "COFRE",
  "COLAR",
  "COMUM",
  "CONDE",
  "CONTA",
  "CORDA",
  "COROA",
  "CRAVO",
  "CRIME",
  "CRISE",
  "CRUEL",
  "CUBOS",
  "CULPA",
  "CURVA",
  "DADOS",
  "DANOS",
  "DUPLA",
  "DISCO",
  "DITOS",
  "DOCAS",
  "DOIDA",
  "DRAMA",
  "DUROS",
  "EIXOS",
  "EPOCA",
  "ESQUI",
  "ETAPA",
  "ETICO",
  "EXAME",
  "EXTRA",
  "FAIXA",
  "FATOR",
  "FATOS",
  "FEBRE",
  "FEIOS",
  "FEITA",
  "FEITO",
  "FENDA",
  "FERAS",
  "FERRO",
  "FIBRA",
  "FICHA",
  "FILHO",
  "FILME",
  "FINOS",
  "FIRME",
  "FIXOS",
  "FOCOS",
  "FONES",
  "FORNO",
  "FRASE",
  "FRIOS",
  "FROTA",
  "FUMAR",
  "FUNDA",
  "FURAR",
  "FUROS",
  "GAITA",
  "GALHO",
  "GANHO",
  "GATAS",
  "GELOS",
  "GEMAS",
  "GENIO",
  "GESTO",
  "GIRAR",
  "GLOBO",
  "GOLFO",
  "GOMOS",
  "GORDA",
  "GORDO",
  "GOTAS",
  "GRAOS",
  "GRAUS",
  "GRAVE",
  "GRADE",
  "GUIAS",
  "HINOS",
  "HORAS",
  "HOTEL",
  "HUMOR",
  "IDADE",
  "IDOLO",
  "IGUAL",
  "INDIO",
  "IRMAO",
  "JOIAS",
  "JUIZO",
  "JUNTO",
  "JURAR",
  "JUROS",
  "JUSTA",
  "LABIA",
  "LACOS",
  "LAGOS",
  "LAZER",
  "LENTE",
  "LESTE",
  "LIDOS",
  "LIXOS",
  "LOURO",
  "LUCRO",
  "LUZES",
  "MACAS",
  "MAGRO",
  "MAIOR",
  "MANIA",
  "MAPAS",
  "MARCA",
  "MASSA",
  "MATOS",
  "MEIOS",
  "MENOR",
  "MESAS",
  "METRO",
  "MIMOS",
  "MINAS",
  "MITOS",
  "MOLHO",
  "MOTEL",
  "MOTOR",
  "MOTOS",
  "MUDAS",
  "MUROS",
  "NASAL",
  "NATAL",
  "NAVAL",
  "NEGRA",
  "NEVOA",
  "NINHO",
  "NIVEL",
  "NOIVA",
  "NOIVO",
  "NORMA",
  "NOVOS",
  "NULOS",
  "OBRAS",
  "OLEOS",
  "ONDAS",
  "ONCAS",
  "OPCAO",
  "OTIMO",
  "PACAS",
  "PALCO",
  "PANOS",
  "PARAR",
  "PARTO",
  "PASSO",
  "PATIO",
  "PAUSA",
  "PECAR",
  "PECAS",
  "PEITO",
  "PENAL",
  "PENAS",
  "PENTE",
  "PERDA",
  "PESOS",
  "PESTE",
  "PIANO",
  "PICOS",
  "PILAR",
  "PILHA",
  "PINOS",
  "PISTA",
  "PLACA",
  "PNEUS",
  "POCOS",
  "POLAR",
  "POLOS",
  "POMBA",
  "POMBO",
  "POVOS",
  "PRAZO",
  "PRECO",
  "PRESO",
  "PROLE",
  "PRUMO",
  "ETICA",
  "SOBRE",
  "MUTUA",
  "SECAO",
  "POREM",
  "SUTIL",
  "FOSSE",
  "SANAR",
  "AUDAZ",
  "MORAL",
  "INATO",
  "DESDE",
  "RAZAO",
  "ETNIA",
  "FUTIL",
  "ANEXO",
  "HAVER",
  "TANGE",
  "ENTAO",
  "EXPOR",
  "GRACA",
  "HABIL",
  "MUTUO",
  "DIZER",
  "ESTAR",
  "PESAR",
  "DEVER",
  "CAUSA",
  "AINDA",
  "SENDO",
  "TEMOR",
  "APICE",
  "GENRO",
  "POSSE",
  "ANIMO",
  "CEDER",
  "PAUTA",
  "CENSO",
  "DETEM",
  "CULTO",
  "ANSIA",
  "DIGNO",
  "VULGO",
  "VICIO",
  "SAUDE",
  "TODOS",
  "PUDOR",
  "JEITO",
  "DOGMA",
  "VALHA",
  "ORDEM",
  "LIMBO",
  "ATRAS",
  "PEDIR",
  "MERCE",
  "IMPOR",
  "BANAL",
  "FORMA",
  "CERTO",
  "PROSA",
  "SERVO",
  "PRESA",
  "POSSO",
  "DESSE",
  "HEROI",
  "CUNHO",
  "FACIL",
  "VENDO",
  "LINDA",
  "SERIO",
  "ACASO",
  "MEIGA",
  "PUDER",
  "FLUIR",
  "TEMER",
  "UNIAO",
  "GERAR",
  "OBTER",
  "OBVIO",
  "AFINS",
  "EXODO",
  "PLENO",
  "RITMO",
  "TEDIO",
  "FLUXO",
  "LEVAR",
  "CASTA",
  "HAVIA",
  "TOMAR",
  "ENFIM",
  "BREGA",
  "FALTA",
  "VITAL",
  "OUTRO",
  "FAVOR",
  "RETER",
  "FORCA",
  "AMENO",
  "UNICO",
  "TENDO",
  "LAICO",
  "NICHO",
  "VALIA",
  "ACHAR",
  "NOSSA",
  "GRATO",
  "REVER",
  "NOCAO",
  "POSSA",
  "FARDO",
  "FACAM",
  "PRIME",
  "FARSA",
  "EPICO",
  "LEIGO",
  "OBITO",
  "CIUME",
  "DETER",
  "CITAR",
  "ATUAR",
  "SINTO",
  "GENTE",
  "HASTE",
  "ADIAR",
  "TENDE",
  "SENAO",
  "ARDUO",
  "TERNO",
  "MARCO",
  "HIATO",
  "FEIXE",
  "EXATO",
  "CAPAZ",
  "AMPLO",
  "DEBIL",
  "TANTO",
  "VEMOS",
  "CAUDA",
  "RAIVA",
  "OTICA",
  "CACAR",
  "AMBOS",
  "SERIE",
  "VACUO",
  "XEQUE",
  "IMUNE",
  "ALGUM",
  "FARAO",
  "VIMOS",
  "FUSAO",
  "ENTRE",
  "LEITO",
  "MINHA",
  "TRAMA",
  "SENTE",
  "BRISA",
  "IMPAR",
  "VERSO",
  "CHATA",
  "RIGOR",
  "PEGAR",
  "SEITA",
  "BOTAR",
  "SAIBA",
  "DORSO",
  "MOCAO",
  "SIGNO",
  "FUROR",
  "FAUNA",
  "OCASO",
  "SENDA",
  "COVIL",
  "CREDO",
  "CASTO",
  "NUNCA",
  "ALIAS",
  "DOCIL",
  "ADEUS",
  "HOUVE",
  "ARDOR",
  "ARIDO",
  "PARTE",
  "SETOR",
  "AMBAS",
  "ANTRO",
  "REZAR",
  "VISSE",
  "ESTAO",
  "VULTO",
  "AVARO",
  "SALVO",
  "VIRUS",
  "MESES",
  "BREVE",
  "VASTO",
  "VERBO",
  "ANAIS",
  "LENDA",
  "OXALA",
  "PRADO",
  "ACIMA",
  "SERAO",
  "CHULO",
  "VIOLA",
  "NACAO",
  "SEGUE",
  "MOTIM",
  "BIRRA",
  "TIRAR",
  "BONUS",
  "TRETA",
  "BRAVA",
  "PUXAR",
  "TOSCO",
  "ATOMO",
  "GERIR",
  "TRAGA",
  "VORAZ",
  "ACESA",
  "LIGAR",
  "NOSSO",
  "MALTA",
  "AONDE",
  "BANDO",
  "ARCAR",
  "COPIA",
  "QUASE",
  "LONGE",
  "AVIAO",
  "AFORA",
  "FATAL",
  "DESSA",
  "SEXTA",
  "PRAGA",
  "CERTA",
  "FIXAR",
  "OASIS",
  "QUOTA",
  "APELO",
  "LIDAR",
  "APEGO",
  "TOCAR",
  "ALADO",
  "SUMIR",
  "TINHA",
  "VEZES",
  "LINDO",
  "BATER",
  "OPACO",
  "SOLTO",
  "SALVE",
  "ELITE",
  "TURVA",
  "VIRAO",
  "DEIXA",
  "GRATA",
  "PARDO",
  "PIQUE",
  "BIOMA",
  "PARVA",
  "ALUNO",
  "DESTA",
  "VIRIA",
  "MENOS",
  "CABER",
  "CALDA",
  "VIDEO",
  "POSTO",
  "RADIO",
  "ABUSO",
  "LAPIS",
  "SUPOR",
  "ZELAR",
  "GOSTO",
  "JUDEU",
  "SUPER",
  "VERBA",
  "TORSO",
  "RUINA",
  "VINHA",
  "VOSSO",
  "PASSA",
  "TRACO",
  "COMBO",
  "ORFAO",
  "CHAMA",
  "MUSEU",
  "ACOES",
  "REFEM",
  "AMENA",
  "PISAR",
  "LOCAL",
  "OPTAR",
  "MESMA",
  "FOREM",
  "MEDIR",
  "BUSCA",
  "TESTE",
  "MEIGO",
  "POEMA",
  "AVISO",
  "FOLGA",
  "GERAL",
  "CORAL",
  "AUTOS",
  "FACTO",
  "COCHO",
  "RUMOR",
  "FEROZ",
  "CALMO",
  "IDOSO",
  "RUBRO",
  "BOATO",
  "VOLTA",
  "PACTO",
  "ACUDE",
  "LICAO",
  "MOVEL",
  "MANGA",
  "ECOAR",
  "DAQUI",
  "CASAR",
  "FALHA",
  "PONHA",
  "MONTE",
  "SALDO",
  "AROMA",
  "CONTO",
  "CACHO",
  "BRIGA",
  "VETAR",
  "ITENS",
  "VIGIA",
  "GRAMA",
  "FORUM",
  "TRIBO",
  "AMADA",
  "LETAL",
  "TROCA",
  "FAZIA",
  "UNICA",
  "RIVAL",
  "UTEIS",
  "PINHO",
  "TCHAU",
  "VENHA",
  "VAZAO",
  "JEJUM",
  "VIRAR",
  "ARADO",
  "NESSE",
  "CARGO",
  "SEIXO",
  "MIDIA",
  "FOSSO",
  "PERTO",
  "MACRO",
  "GIRIA",
  "MAGNA",
  "ROCHA",
  "BRUTO",
  "TUTOR",
  "TODAS",
  "AXILA",
  "TIVER",
  "INTER",
  "FARTA",
  "RENDA",
  "POMAR",
  "ASSAR",
  "TENHA",
  "BRUTA",
  "TRAJE",
  "DESTE",
  "TRATO",
  "SURTO",
  "PORTE",
  "AMADO",
  "AMBAR",
  "NESSA",
  "GURIA",
  "VERAO",
  "PERCO",
  "RURAL",
  "ODIAR",
  "VIRAM",
  "MAMAE",
  "DEPOR",
  "VISTA",
  "LAUDO",
  "NEGAR",
  "NESTA",
  "QUAIS",
  "FOSSA",
  "SALMO",
  "MINAR",
  "CERCA",
  "PAVOR",
  "DENSA",
  "CHEIA",
  "CIFRA",
  "RECEM",
  "IRADO",
  "VISTO",
  "VAGAR",
  "BURRA",
  "HORTO",
  "RUIDO",
  "INVES",
  "MOLDE",
  "SOTAO",
  "LESAO",
  "TRAGO",
  "PENSO",
  "VELHA",
  "QUEDA",
  "VASTA",
  "OLHOS",
  "TROCO",
  "PICHE",
  "PODAR",
  "FOLIA",
  "DERAM",
  "AUDIO",
  "OUTRA",
  "NESTE",
  "DISSO",
  "MONTA",
  "ILESO",
  "MATAR",
  "COSMO",
  "SEIVA",
  "MANTO",
  "CHAGA",
  "REDOR",
  "SACAR",
  "FALSA",
  "RETRO",
  "MOVER",
  "MISTO",
  "BOLSO",
  "VAZIA",
  "CIVEL",
  "VELOZ",
  "LONGO",
  "SAMBA",
  "BARAO",
  "SABOR",
  "ALBUM",
  "MIMAR",
  "ZUMBI",
  "AXIAL",
  "MACHO",
  "GEMER",
  "PAGAR",
  "PORCA",
  "DIABO",
  "ENJOO",
  "FARTO",
  "SALVA",
  "XAMPU",
  "LOUSA",
  "VENHO",
  "VALER",
  "BAIXA",
  "OUSAR",
  "BRUXA",
  "SEXTO",
  "HIFEN",
  "FIRMA",
  "REPOR",
  "SIGLA",
  "TORNA",
  "FORRO",
  "SOLTA",
  "CHOCA",
  "FEIRA",
  "GUETO",
  "RELER",
  "FUGIU",
  "FAZES",
  "SADIO",
  "CANIL",
  "FERIR",
  "VERSA",
  "SOCIO",
  "SUGAR",
  "MIOPE",
  "DIGNA",
  "TUMBA",
  "FURIA",
  "SARRO",
  "SERRA",
  "SURRA",
  "BRASA",
  "MANHA",
  "POLIR",
  "ABADE",
  "ABALO",
  "ACENO",
  "ADEGA",
  "AGITO",
  "AGUAS",
  "ALEGA",
  "ALVOS",
  "ANIMA",
  "ZANGA",
  "ANZOL",
  "APITO",
  "ARCOS",
  "ARMAS",
  "BALAS",
  "BARCA",
  "BASTA",
  "BATOM",
  "BICOS",
  "BODAS",
  "BOLAS",
  "BOLOS",
  "CACHE",
  "CALDO",
  "CANOA",
  "CANTA",
  "CAPIM",
  "CASCO",
  "CAVAR",
  "CEDRO",
  "CIRCO",
  "COBRE",
  "COPAS",
  "CORES",
  "COSTA",
  "CREME",
  "CRUZA",
  "DEDAL",
  "DIVAS",
  "DUELO",
  "ERVAS",
  "FACAS",
  "FADAS",
  "FOGAO",
  "FRAGA",
  "FRETE",
  "FRIAS",
  "FUNGO",
  "GARRA",
  "GASTO",
  "GESSO",
  "HORTA",
  "JOGOS",
  "LAGOA",
  "LATAS",
  "LAVAR",
  "LENCO",
  "LENHA",
  "MALHA",
  "MARES",
  "MEDIO",
  "MOEDA",
  "MORNO",
  "NEVES",
  "ODEIO",
  "OLIVA",
  "PALHA",
  "PAPAI",
  "PEDAL",
  "PERNA",
  "PINGO",
  "PIRES",
  "POLVO",
  "PRIMO",
  "PULSO",
  "RADAR",
  "RAMOS",
  "RIMAS",
  "RODAS",
  "ROSAS",
  "SALSA",
  "SEDAS",
  "SELVA",
  "SETAS",
  "SUCOS",
  "TALCO",
  "TORRE",
  "TUBOS",
  "VAGAS",
  "VELAS",
  "VIDAS",
  "VINHO",
  "ABRIL",
  "ADAGA",
  "AFIAR",
  "AGUDA",
  "ALIAR",
  "AMOLA",
  "ANEIS",
  "RASGO",
  "ATRAI",
  "BALSA",
  "BANHA",
  "BEIRA",
  "BOLHA",
  "BONDE",
  "BORDO",
  "CABRA",
  "CACAU",
  "CALAR",
  "CANJA",
  "CASCA",
  "CERCO",
  "COVAS",
  "DELTA",
  "DORES",
  "DRAGA",
  "DUNAS",
  "EDITA",
  "ENCHE",
  "ERGUE",
  "EXATA",
  "FATIA",
  "FINCA",
  "FLOCO",
  "FOICE",
  "GANSO",
  "GAROA",
  "GELAR",
  "GRAXA",
  "GRUTA",
  "HELIO",
  "HIENA",
  "IDOSA",
  "JANTA",
  "JARRA",
  "JORRO",
  "JULGO",
  "JUNTA",
  "LASCA",
  "LEQUE",
  "LOTES",
  "MAGRA",
  "MALES",
  "MANTA",
  "MATAS",
  "MELAR",
  "MICOS",
  "MOFAR",
  "MOITA",
  "MORDE",
  "MULAS",
  "MULTA",
  "NOTAR",
  "NOVAS",
  "PALMA",
  "PESCA",
  "PICAR",
  "PINTA",
  "POLEN",
  "PONTA",
  "POSTA",
  "ROLHA",
  "FUZIL",
  "CHORA",
  "RAMPA",
  "LUTAS",
  "DOLAR",
  "BROTO",
  "SOMOS",
  "ABATE",
  "ADORA",
  "AGIDO",
  "ALUGA",
  "AMARO",
  "AMORA",
  "APURA",
  "ARDER",
  "ASILO",
  "ATIVA",
  "AZEDO",
  "BACIA",
  "BALDE",
  "BEIJA",
  "BELOS",
  "BINGO",
  "BISPO",
  "BOATE",
  "BODES",
  "BREJO",
  "BRUXO",
  "BUSTO",
  "CACAS",
  "CALOU",
  "CAROS",
  "CARPA",
  "CASPA",
  "CELAS",
  "CHALE",
  "CHAPA",
  "CILIO",
  "CLIPE",
  "COICE",
  "COMES",
  "CONTE",
  "CORNO",
  "CORVO",
  "COURO",
  "CREPE",
  "CROMO",
  "CUIAS",
  "DAMAS",
  "DATAS",
  "DICAS",
  "DIETA",
  "DOSES",
  "DONAS",
  "DUCHA",
  "ELEVA",
  "ENTRA",
  "ESPIA",
  "ESTAS",
  "EXIGE",
  "FARPA",
  "FASES",
  "FEIAS",
  "FILAS",
  "FITAS",
  "FRADE",
  "FREAR",
  "FUZIS",
  "GANHA",
  "GEADA",
  "GOMAS",
  "GUIAR",
  "GRANA",
  "GRAVA",
  "MICRO",
  "VEADO",
  "ABRAM",
  "ABREM",
  "ABRIA",
  "ABRIU",
  "ACABA",
  "ACABE",
  "ACABO",
  "ACHAM",
  "ACHAS",
  "ACHEI",
  "ACHOU",
  "ACUSA",
  "ADORO",
  "ADOTA",
  "AEREO",
  "AFETA",
  "AJUDE",
  "AJUDO",
  "ALEMA",
  "ALGAS",
  "ALMAS",
  "ALTAS",
  "ALTOS",
  "ALUNA",
  "AMAVA",
  "ANDAM",
  "ANDAS",
  "ANDEI",
  "ANDOU",
  "ANOES",
  "ANTAS",
  "ANULA",
  "AORTA",
  "APAGA",
  "APELA",
  "APOIA",
  "APOIE",
  "ARABE",
  "ARAME",
  "AREAL",
  "ARMAR",
  "ASPAS",
  "ATACA",
  "ATIRA",
  "ATIRE",
  "ATUAM",
  "ATUOU",
  "AVISA",
  "AVISE",
  "AZUIS",
  "BABAR",
  "BAIAO",
  "BAILE",
  "BAITA",
  "BAIXE",
  "BAMBU",
  "BANCA",
  "BANIR",
  "BARES",
  "BARRA",
  "BASCO",
  "BATEM",
  "BATEU",
  "BATIA",
  "BEBEM",
  "BEBES",
  "BEBEU",
  "BEIJE",
  "BELAS",
  "BELGA",
  "BENTO",
  "BERCO",
  "BESTA",
  "BOINA",
  "BOSSA",
  "BOTAO",
  "BOTOU",
  "BROCA",
  "BUQUE",
  "BUSCO",
  "CABEM",
  "CAFES",
  "CAIAM",
  "CAIDO",
  "CANSA",
  "CANTE",
  "CAPAO",
  "CAPUZ",
  "CARGA",
  "CASAM",
  "CASOS",
  "CASOU",
  "CATAR",
  "CEDEU",
  "CEGAS",
  "CEGOS",
  "CELTA",
  "CENTO",
  "CERVO",
  "CHAME",
  "CHAMO",
  "CHECA",
  "CHEGA",
  "CHEGO",
  "CHITA",
  "CHORE",
  "CHOVE",
  "CHUPA",
  "CHUTA",
  "CISNE",
  "CITOU",
  "CIVIS",
  "CLORO",
  "COLHE",
  "COMEM",
  "COMEU",
  "COMIA",
  "COQUE",
  "CORRA",
  "CORRE",
  "CORRI",
  "CORRO",
  "CORTA",
  "CORTO",
  "COSPE",
  "COTAS",
  "COUBE",
  "COUVE",
  "COXAS",
  "CREIO",
  "CRIAM",
  "CRIAS",
  "CRIEI",
  "CRIOU",
  "CRUZE",
  "CUBRA",
  "CUECA",
  "CUIDA",
  "CUIDE",
  "CUIDO",
  "CUJOS",
  "CUNHA",
  "CUPOM",
  "CURAR",
  "CURTA",
  "CURTE",
  "CURTI",
  "CUSTA",
  "CUSTE",
  "DADAS",
  "DAMOS",
  "DANCO",
  "DANDO",
  "DARAO",
  "DARDO",
  "DAREI",
  "DAREM",
  "DARIA",
  "DAVAM",
  "DEITA",
  "DEITE",
  "DEIXE",
  "DEIXO",
  "DELAS",
  "DELES",
  "DEMOS",
  "DEREM",
  "DESCE",
  "DEVEM",
  "DEVES",
  "DEVIA",
  "DIGAM",
  "DIRAO",
  "DIREI",
  "DIRIA",
  "DISSE",
  "DISTO",
  "DITAS",
  "DIZEM",
  "DIZES",
  "DIZIA",
  "DOADO",
  "DOBRA",
  "DOBRO",
  "DONDE",
  "DORME",
  "DORMI",
  "DROGA",
  "DUETO",
  "DUPLO",
  "DUQUE",
  "DURAM",
  "DURAO",
  "DURAR",
  "DURAS",
  "DURMA",
  "DURMO",
  "DUROU",
  "DUZIA",
  "EDEMA",
  "EMANA",
  "EMITE",
  "ENFIA",
  "ENTRO",
  "ENVIA",
  "ENVIE",
  "ENVIO",
  "EPICA",
  "ERRAR",
  "ERREI",
  "ERROU",
  "ESSES",
  "ESTOU",
  "EVITA",
  "EVITE",
  "EVOCA",
  "EXIBE",
  "EXPOE",
  "EXPOS",
  "FALAM",
  "FALEI",
  "FALEM",
  "FALIR",
  "FALOU",
  "FARDA",
  "FAREI",
  "FARIA",
  "FARRA",
  "FAZEM",
  "FECHA",
  "FECHE",
  "FECHO",
  "FEDOR",
  "FEMEA",
  "FERIU",
  "FERVE",
  "FETOS",
  "FEZES",
  "FICAM",
  "FICAS",
  "FICOU",
  "FIEIS",
  "FILHA",
  "FILMA",
  "FINAS",
  "FINGE",
  "FIQUE",
  "FIZER",
  "FOBIA",
  "FOFAS",
  "FOFOS",
  "FOGEM",
  "FOMOS",
  "FORAM",
  "FOSTE",
  "FOTOS",
  "FRACA",
  "FREIO",
  "FRITA",
  "FRITO",
  "FUNIL",
  "FURTO",
  "GAMBA",
  "GANHE",
  "GASES",
  "GASTA",
  "GEMEO",
  "GERAM",
  "GEROU",
  "GIBIS",
  "GIROS",
  "GOELA",
  "GOLFE",
  "GOSTA",
  "GOSTE",
  "GOZAR",
  "GREGA",
  "GREGO",
  "GREVE",
  "GRIFE",
  "GRIPE",
  "GRITA",
  "HARPA",
  "IAMOS",
  "IMITA",
  "IMPOE",
  "IMPOS",
  "INDUZ",
  "IRIAM",
  "IRMAS",
  "IRMOS",
  "ISOLA",
  "JAULA",
  "JOGAM",
  "JOGOU",
  "JOGUE",
  "JUDIA",
  "JUIZA",
  "JULGA",
  "JULHO",
  "JUNHO",
  "JUNTE",
  "JUREI",
  "JUROU",
  "LABIO",
  "LACRE",
  "LADRA",
  "LAMBE",
  "LANCA",
  "LANCE",
  "LARGA",
  "LATIM",
  "LEAIS",
  "LEIAM",
  "LEMOS",
  "LENDO",
  "LERAM",
  "LEVAM",
  "LEVEI",
  "LEVEM",
  "LEVES",
  "LEVOU",
  "LIBRA",
  "LICEU",
  "LICOR",
  "LIDAM",
  "LIDAS",
  "LIGAM",
  "LIGAS",
  "LIGOU",
  "LIGUE",
  "LIMPA",
  "LIMPE",
  "LINHO",
  "LIRIO",
  "LISTA",
  "LITIO",
  "LITRO",
  "LIVRA",
  "LIXAO",
  "LOIRA",
  "LOIRO",
  "LOMBO",
  "LONGA",
  "LORDE",
  "LUTAM",
  "LUTOU",
  "MACIA",
  "MADRE",
  "MAGMA",
  "MAGNO",
  "MALTE",
  "MAMAR",
  "MAMAS",
  "MAMBO",
  "MANDA",
  "MANDE",
  "MANDO",
  "MANOS",
  "MARTA",
  "MATAM",
  "MATEI",
  "MATEM",
  "MATOU",
  "MENTA",
  "MEROS",
  "METAS",
  "METER",
  "METEU",
  "MEXEU",
  "MILHA",
  "MIRAR",
  "MIRIM",
  "MISSA",
  "MISTA",
  "MIUDA",
  "MIUDO",
  "MODOS",
  "MORAM",
  "MOREI",
  "MOROU",
  "MORRA",
  "MORRE",
  "MORRI",
  "MORTA",
  "MORTO",
  "MOVEM",
  "MOVEU",
  "MUDAM",
  "MUDEI",
  "MUDEM",
  "MUDOU",
  "MUITA",
  "MUMIA",
  "MUSAS",
  "NAIPE",
  "NARRA",
  "NASCE",
  "NASCI",
  "NAVES",
  "NEGAO",
  "NEGOU",
  "NERVO",
  "NETOS",
  "NISSO",
  "NISTO",
  "NOMES",
  "NOTEI",
  "NOTOU",
  "NOZES",
  "NUDEZ",
  "OBTEM",
  "OBVIA",
  "OCUPA",
  "ODEIA",
  "ODIEI",
  "OESTE",
  "OLHAM",
  "OLHEI",
  "OLHEM",
  "OLHOU",
  "OMBRO",
  "OPINA",
  "OPTOU",
  "ORAIS",
  "OUCAM",
  "OUVEM",
  "OUVIA",
  "OUVIU",
  "OVULO",
  "OXIDO",
  "PAGAM",
  "PAGAS",
  "PAGOS",
  "PAGOU",
  "PAGUE",
  "PARAM",
  "PAREI",
  "PAREM",
  "PARES",
  "PARIU",
  "PAROU",
  "PARRA",
  "PARTA",
  "PARTI",
  "PASSE",
  "PASTA",
  "PASTO",
  "PAVAO",
  "PECAM",
  "PEDEM",
  "PEDIA",
  "PEDIU",
  "PEGAM",
  "PEGOS",
  "PEGOU",
  "PEGUE",
  "PELAS",
  "PELES",
  "PENSA",
  "PENSE",
  "PEOES",
  "PERCA",
  "PERDE",
  "PERDI",
  "PERSA",
  "PINTO",
  "PIORA",
  "PIPAS",
  "PISCA",
  "PISOS",
  "PISOU",
  "PLANA",
  "PODEM",
  "PODES",
  "PODIA",
  "PODIO",
  "PODRE",
  "POLPA",
  "PONDO",
  "PONHO",
  "PORAO",
  "POSTE",
  "POTES",
  "POTRO",
  "POUCA",
  "POUPA",
  "POUPE",
  "POUSO",
  "PRACA",
  "PREGA",
  "PREGO",
  "PRETA",
  "PREVE",
  "PRIMA",
  "PUDIM",
  "PULOU",
  "PUNHO",
  "PUNIR",
  "PUROS",
  "PUXOU",
  "QUERO",
  "QUILO",
  "QUINA",
  "RACAO",
  "RACHA",
  "RAIOS",
  "RAMAL",
  "RAPTO",
  "RARAS",
  "RAROS",
  "RASGA",
  "REAGE",
  "REAIS",
  "RECUO",
  "REDES",
  "REDUZ",
  "REGAR",
  "REGUA",
  "REINA",
  "RENAL",
  "RENDE",
  "RESTA",
  "REUNE",
  "RICAS",
  "RICOS",
  "RIMEL",
  "RINDO",
  "RISCA",
  "ROBOS",
  "RODAR",
  "ROLAR",
  "ROLOU",
  "ROMBO",
  "ROMPE",
  "RONCO",
  "RONDA",
  "ROSCA",
  "ROSTO",
  "ROTAS",
  "ROUBA",
  "ROUBO",
  "RUGAS",
  "RUINS",
  "RUIVA",
  "RUIVO",
  "RUMOS",
  "RUSSA",
  "RUSSO",
  "SABAO",
  "SABEM",
  "SABES",
  "SABRE",
  "SACOS",
  "SAFRA",
  "SAIAM",
  "SAIDO",
  "SAIRA",
  "SALAO",
  "SALAS",
  "SALTA",
  "SAQUE",
  "SARAR",
  "SECAR",
  "SECAS",
  "SECOS",
  "SEDUZ",
  "SEGUI",
  "SEIOS",
  "SEJAM",
  "SEJAS",
  "SELOS",
  "SENHA",
  "SENTA",
  "SENTI",
  "SENTO",
  "SERAS",
  "SEREI",
  "SEREM",
  "SERES",
  "SERIA",
  "SEXOS",
  "SIGAM",
  "SINTA",
  "SIRVA",
  "SIRVO",
  "SISMO",
  "SITUA",
  "SOBEM",
  "SOBRA",
  "SOCAR",
  "SOCIA",
  "SOCOS",
  "SODIO",
  "SOFRA",
  "SOFRE",
  "SOFRI",
  "SOFRO",
  "SOGRA",
  "SOGRO",
  "SOLOS",
  "SOLTE",
  "SOMAM",
  "SOMAR",
  "SOMOU",
  "SONDA",
  "SONHA",
  "SOPRO",
  "SOUBE",
  "SUBIU",
  "SUECA",
  "SUECO",
  "SUICA",
  "SUICO",
  "SUJAR",
  "SUJAS",
  "SUMIU",
  "SUPOE",
  "SURDA",
  "SURDO",
  "SURFE",
  "SURGE",
  "SUSTO",
  "SUTIA",
  "TABUA",
  "TACAS",
  "TANGA",
  "TANTA",
  "TAPAR",
  "TARDA",
  "TARJA",
  "TARSO",
  "TAXAS",
  "TECLA",
  "TELHA",
  "TEMAS",
  "TEMEM",
  "TEMIA",
  "TEMOS",
  "TENDA",
  "TENHO",
  "TENSA",
  "TENTA",
  "TENTE",
  "TERAO",
  "TERCA",
  "TERCO",
  "TEREI",
  "TEREM",
  "TERES",
  "TERIA",
  "TESTA",
  "TIARA",
  "TINTO",
  "TIPOS",
  "TIRAM",
  "TIRAS",
  "TIREI",
  "TIREM",
  "TIROS",
  "TIROU",
  "TOCAM",
  "TOCHA",
  "TOCOU",
  "TOMAM",
  "TOMBA",
  "TOMBO",
  "TOMEI",
  "TOMEM",
  "TOMOU",
  "TONTA",
  "TONTO",
  "TORAX",
  "TORCE",
  "TORNE",
  "TORNO",
  "TORTO",
  "TOSSE",
  "TOTEM",
  "TOUCA",
  "TRAIR",
  "TRAIU",
  "TRARA",
  "TRATA",
  "TRATE",
  "TRAVA",
  "TRAVE",
  "TREME",
  "TRENS",
  "TREZE",
  "TRICO",
  "TRIOS",
  "TRONO",
  "TROTE",
  "TRUTA",
  "TUFAO",
  "TUNEL",
  "TURCA",
  "TURCO",
  "TURNE",
  "TURNO",
  "UNIDA",
  "UNIDO",
  "URINA",
  "URNAS",
  "URUBU",
  "USADO",
  "USAVA",
  "USINA",
  "UTERO",
  "VAGAO",
  "VALEM",
  "VALES",
  "VALEU",
  "VALSA",
  "VAPOR",
  "VARAL",
  "VARIA",
  "VAZAR",
  "VAZOU",
  "VEJAM",
  "VENCA",
  "VENCE",
  "VENCI",
  "VENDA",
  "VENDE",
  "VEREI",
  "VEREM",
  "VERIA",
  "VERME",
  "VESPA",
  "VESTE",
  "VIAJA",
  "VIAJE",
  "VIBRA",
  "VIDRO",
  "VILAS",
  "VINDA",
  "VINDO",
  "VINIL",
  "VINTE",
  "VIREI",
  "VIREM",
  "VIROU",
  "VISAM",
  "VISOR",
  "VISTE",
  "VIUVA",
  "VIUVO",
  "VIVAM",
  "VIVAS",
  "VIVEM",
  "VIVEU",
  "VIVIA",
  "VIVOS",
  "VOLEI",
  "VOLTE",
  "VOLTO",
  "VOTAM",
  "VOTAR",
  "VOTEM",
  "VOTOS",
  "VOTOU",
  "VOZES",
  "ZERAR",
  "ZINCO",
  "ZIPER",
  "ZONAS",
  "XEROX",
  "CIANO",
  "TACOS",
  "TOCOS",
  "VOCES",
  "ESSAS",
  "ESTES",
  "PORTO",
  "TOTAL",
  "MEDIA",
  "USADA",
  "SERVE",
  "OTIMA",
  "SITES",
  "SOLAR",
  "LADOS",
  "SHOWS",
  "LOJAS",
  "LINKS",
  "ARENA",
  "AEREA",
  "EMAIL",
  "BASES",
  "VOSSA",
  "ANIME",
  "PIZZA",
];
